import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Accounts_Ip_Whitelists_Object} state
 *  @property {object} model
 *  @property {Accounts_Ip_Whitelists_Properties} model.properties
 *  @property {Accounts_Ip_Whitelists_Is} model.is
 *  @property {Accounts_Ip_Whitelists_Has} model.has
 */
export default class IpWhitelists extends ObjectOverride {
	constructor(props) {
		super(props, Types.Accounts_Ip_Whitelists._name);
	}

	form = () => {
		/** @type {Accounts_Ip_Whitelists_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Ip_Whitelists_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">IP Whitelist</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"IP To Whitelist"}
									value={object.ip_address}
									error={object.ip_address_error}
									property={properties.ip_address}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
